// vertical space between two rows - keep in sync with $gap in skin/ui5/navigation/menu/item/item.styles.scss
export const MENU_PROJECTS_ROW_GAP = 3

export type MenuProjectsDropRect = {
    left    : number
    right   : number
    top     : number
    bottom  : number
}

// A row's own rect stops at its bottom edge, so consecutive rows do not tile - the gap between them
// belongs to no row at all. A cursor resting there is dragged over nothing: the insertion line blinks
// out and a drop does nothing. Giving every row the gap below it closes the hole, and puts the gap in
// the same zone (bottom third) as the row edge it sits under, so the line does not move either.
export default function menuProjects_dropRect(rect: MenuProjectsDropRect): MenuProjectsDropRect {
    return {
        left    : rect.left,
        right   : rect.right,
        top     : rect.top,
        bottom  : rect.bottom + MENU_PROJECTS_ROW_GAP,
    }
}
